export default [

     {
          path: '/exam',
          name: 'Exam',
          component: () => import("@/views/Page/Exam/Exam.vue"),
          meta: {
               title: 'Exam',
          },
     }
];